import App from './App.vue'
import Router from 'vue-router'
import getRoutes from './routes'
import Vue from 'vue'

Vue.use(Router)

const mount = document.querySelector('#search-results')

// Create a Vue instance only if we are on the search results page
if (mount) {
  const source = mount.dataset.source
  Vue.prototype.$source = source

  const router = new Router({
    mode: process.env.SEARCH_ROUTER_MODE,
    routes: getRoutes()
  })

  new Vue({
    router,
    render: h => h(App)
  }).$mount(mount)
}
